// extracted by mini-css-extract-plugin
module.exports = {"map-trigger":"map-trigger--qhQKF"};